import api from '../api/axiosClient';

export interface RegisterRequest {
  username: string;
  password: string;
  fullName: string;
  email: string;
  phone: string;
  roleId: number;
  makeupArtistId: number;
}

export interface RegisterResponse {
  message: string;
}

const BASE = '/Auth';

export const registerUser = async (data: RegisterRequest): Promise<RegisterResponse> => {
  const res = await api.post<RegisterResponse>(`${BASE}/Register`, data);
  return res.data;
};

// Availability check response (speculative; backend implementation required)
export interface AvailabilityResponse {
  usernameExists?: boolean;
  emailExists?: boolean;
  phoneExists?: boolean;
}

// Attempts to query optional availability endpoint. If 404 or network error, returns empty object.
export const checkAvailability = async (
  params: { username?: string; email?: string; phone?: string }
): Promise<AvailabilityResponse> => {
  try {
    const query = new URLSearchParams();
    if (params.username) query.append('username', params.username);
    if (params.email) query.append('email', params.email);
    if (params.phone) query.append('phone', params.phone);
    const res = await api.get<AvailabilityResponse>(`${BASE}/Availability?${query.toString()}`);
    return res.data || {};
  } catch (err: any) {
    // Silently ignore if endpoint not present
    if (err?.response?.status === 404) return {};
    return {};
  }
};

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  message: string;
}

export const changePassword = async (
  data: ChangePasswordRequest
): Promise<ChangePasswordResponse> => {
  const res = await api.post<ChangePasswordResponse>(`${BASE}/ChangePassword`, data);
  return res.data;
};
